import type { State } from 'state';
import type { Flag } from 'state/ui/flags';

export const getFlags = (state: State): Flag[] => {
	return state.ui.flags.flags;
};
